import { createAction, props } from "@ngrx/store";

export const setMenuAct = createAction('setMenuEffect', props <{ menuCode: string }>());